/* IIG London: shared behaviour for the iig-* sections.
   - Scroll reveals (.iig-reveal), switched off by prefers-reduced-motion.
   - ?xray=1 review flag. */
(() => {
  const root = document.documentElement;
  root.classList.add('iig-js');

  if (new URLSearchParams(location.search).get('xray') === '1') {
    root.classList.add('iig-xray');
  }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = (scope = document) => {
    const items = scope.querySelectorAll('.iig-reveal:not(.is-visible)');
    if (!items.length) return;

    if (reduce.matches || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
    items.forEach((el) => io.observe(el));
  };

  window.IIG = Object.assign(window.IIG || {}, { reveal, reduceMotion: reduce });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reveal());
  } else {
    reveal();
  }

  // Theme editor: re-run when a section is added or changed.
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
})();
